import dynamic from 'next/dynamic';
const PopoverWrapper = dynamic(() => import('./PopoverWrapper'));

export { PopoverWrapper };
